import { Dialog, DialogTitle, Typography } from "@material-ui/core"
import CreateAdminForm from "components/Forms/CreateAdminForm"
import AppContext from "contexts/App"
import { useState } from "react"
import { useContext } from "react"

import CreatedMessage from "./CreatedMessage"
import useStyles from "./styles"

const CreateSuperAdmin = () => {
  const classes = useStyles()

  const { dialogs, closeDialog } = useContext(AppContext)
  const thisDialog = dialogs?.["createAdmin"] || {}
  const { open = false, data = {} } = thisDialog
  let fromEntity = data?.from === "entity"
  let entityId = data?.entityId

  const [step, setStep] = useState(0)
  const [emailSent, setEmailSent] = useState("")

  const handleClose = () => {
    closeDialog("createAdmin")
    setTimeout(() => {
      setStep(0)
      setEmailSent("")
    }, [200])
  }

  const steps = [
    <CreateAdminForm
      key={1}
      handleClose={handleClose}
      setStep={setStep}
      setEmailSent={setEmailSent}
      fromEntity={fromEntity}
      entityId={entityId}
    />,
    <CreatedMessage key={2} email={emailSent} handleClose={handleClose} />,
  ]

  return (
    <Dialog open={open} classes={{ paperWidthSm: classes.paper }}>
      <DialogTitle disableTypography>
        <Typography variant="h2">
          Invite {`${fromEntity ? "Admin" : "Super Admin"}`}
        </Typography>
      </DialogTitle>
      {steps[step]}
    </Dialog>
  )
}

export default CreateSuperAdmin
